"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClaimBase = /** @class */ (function () {
    function ClaimBase() {
    }
    return ClaimBase;
}());
exports.default = ClaimBase;
//# sourceMappingURL=ClaimBase.js.map